import cn from 'classnames'
import * as React from 'preact/compat'
import { useCallback } from 'preact/compat'

import { sgVersion, showModal } from '#js/common/helpers'

import SVG from '#components/SVG'
import type { SearchItemProps } from '#components/Search/SearchPanel'

import styles from '#css/search-panel.pcss.json'

const statusIcons = {
  0: 'wishlist',
  1: 'playing',
  2: 'beaten',
  3: 'sleep'
}

export default ({ item, isLoggedIn }: SearchItemProps) => {
  let platforms = item.platforms ? item.platforms.map(({ code }) => code).join(', ') : '';

  if (platforms.length === 0) {
    platforms = 'Не указаны'
  }

  const showStatusDialog = useCallback((e: React.TargetedEvent<HTMLButtonElement>) => {
    e.preventDefault()
    import(`/dist/js/components/GameStatusDialog.js?${sgVersion()}`)
      .then(({ default: GameStatusDialog }) => {
        showModal(GameStatusDialog, {
          // @ts-ignore
          gameId: `${item.id}`,
          iconSet: 'colorable',
          element: e.currentTarget
        })
      })
  }, [item.id])

  let toLibraryOptions: React.JSX.HTMLAttributes<HTMLButtonElement> & {
    'data-plugins'?: string
  } = {
    className: styles['game-card__status-button'],
    'data-plugins': 'auth'
  }

  if (isLoggedIn) {
    toLibraryOptions = {
      className: styles['game-card__status-button'],
      onClick: showStatusDialog,
    }
  }

  let statusButton = <button
    type='button'
    {...toLibraryOptions}
  >
    <div data-game-watch-icon={true}>
      <SVG i='sg-new/plus' adaptive/>
    </div>
  </button>

  if (typeof item.status === 'number' && item.status > -1) {
    statusButton = <button
      type='button'
      {...toLibraryOptions}
    >
      <SVG
        i={`game-status/colorable/${statusIcons[item.status]}`}
        data-game-watch-icon={true}
        data-game-watch-icon-status={statusIcons[item.status]}
      />
    </button>
  }

  return <a href={item.url} className={styles['game-card']} data-game-card={true}>
    <div className={styles['game-card__top']}>
      <img
        alt={item.title}
        src={item.square_poster}
        className={styles['game-card__poster']}
        data-game-card-image={true}
      />
      {statusButton}
      <span
        className={cn({
          [styles['game-card__rating']]: true,
          [styles['game-card__rating--green']]: item.rating > 3,
          [styles['game-card__rating--orange']]: item.rating > 2 && item.rating <= 3,
          [styles['game-card__rating--red']]: item.rating > 0 && item.rating <= 2
        })}
      >
        {item.rating}
      </span>
    </div>
    <div className={styles['game-card__bottom']}>
      <div>
        <h3 className={styles['game-card__title']} data-game-card-title={true}>{item.title}</h3>
        <p className={styles['game-card__platforms']}>{platforms}</p>
      </div>
      <div>
        <p className={styles['game-card__date']}>{item.date}</p>
      </div>
    </div>
  </a>
}
